<template>
  <div class="page_box">
    <div class="page_option_box">
      <div class="option_box">
        <el-button
          type="primary"
          plain
          size="mini"
          icon="el-icon-circle-plus-outline"
          @click="addClick"
        >
          新增
        </el-button>
      </div>
    </div>
    <div class="page_table_box">
      <div class="school_table_box">
        <el-table
          :data="responseData.list"
          height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
        >
          <el-table-column label="序号" width="70" align="center">
            <template slot-scope="scope">
              {{
                requestData.pageSize * (requestData.pageNum - 1) +
                  scope.$index +
                  1
              }}
            </template>
          </el-table-column>
          <el-table-column prop="name" label="检测仪名称" align="center">
          </el-table-column>
          <el-table-column
            prop="installationLocation"
            label="安装地点"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="deviceSnCode" label="设备SN码" align="center">
          </el-table-column>
          <el-table-column prop="creationTime" label="创建时间" align="center">
            <template slot-scope="scope">
              {{ $Common.dateFormatDateTwo(scope.row.creationTime) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180" align="center">
            <template slot-scope="scope">
              <el-link
                v-if="scope.row.alarmHandler == 0"
                class="link_box"
                type="primary"
                :underline="false"
                @click="editClick(scope.row)"
                >编辑</el-link
              >
              <el-divider
                direction="vertical"
                v-if="scope.row.alarmHandler == 0"
              ></el-divider>
              <el-link
                class="link_box"
                type="primary"
                :underline="false"
                @click="deldteClick([scope.row.id])"
                >删除</el-link
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination_box">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="requestData.pageNum"
          :page-size="requestData.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="responseData.total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      :append-to-body="true"
      :title="drawerType == 'add' ? '新增消防设备' : '编辑消防设备'"
      :visible.sync="showDrawer"
      direction="ltr"
      :wrapperClosable="false"
      :close-on-press-escape="false"
      :before-close="handleClose"
    >
      <el-form
        :model="objInfo"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="drawer-form-box"
      >
        <el-form-item label="检测仪名称:" prop="name">
          <el-input
            v-model.trim="objInfo.name"
            clearable
            size="small"
            style="width:90%"
          ></el-input>
        </el-form-item>
        <el-form-item label="安装地点:" prop="installationLocation">
          <el-input
            v-model.trim="objInfo.installationLocation"
            clearable
            size="small"
            style="width:90%"
          ></el-input>
        </el-form-item>
        <el-form-item label="设备SN码:" prop="deviceSnCode">
          <el-input
            v-model.trim="objInfo.deviceSnCode"
            clearable
            size="small"
            style="width:90%"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-divider></el-divider>
      <div class="drawer-save-btn-box">
        <el-button
          type="primary"
          size="small"
          @click="saveForm('ruleForm')"
          v-loading="saveLoading"
          >提交</el-button
        >
        <el-button @click="handleClose" size="small" v-loading="saveLoading"
          >返回</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "AirQualityInspection",
  components: {},
  props: {},
  data() {
    return {
      requestData: {
        schoolId: this.$store.state.schoolId,
        pageSize: 20,
        pageNum: 1
      },
      responseData: {
        total: 100,
        list: []
      },
      drawerType: "add",
      showDrawer: false,
      objInfo: {
        deviceSnCode: "", //设备SN码
        installationLocation: "", //安装地点
        name: "", //名称
        schoolId: this.$store.state.schoolId, //所属学校
        id: ""
      },
      saveLoading: false,
      rules: {
        name: [{ required: true, message: " ", trigger: "blur" }],
        installationLocation: [
          { required: true, message: " ", trigger: "blur" }
        ],
        deviceSnCode: [{ required: true, message: "  ", trigger: "blur" }]
      }
    };
  },
  watch: {},
  computed: {},
  methods: {
    handleCurrentChange(val) {
      this.requestData.pageNum = val;
      this.searchClick();
    },
    async searchClick() {
      let res = await this.$Http.getAirTestingList(this.requestData, true);
      if (res.code == 200) {
        this.responseData.list = res.data.list || [];
        this.responseData.total = res.data.total || 0;
      } else if (res.code == 101) {
        this.responseData.list = [];
        this.responseData.total = 0;
      } else {
        this.responseData.list = [];
        this.responseData.total = 0;
        this.$message({
          type: "error",
          message: res.messsage || "空气检测仪列表获取失败"
        });
      }
    },
    // 新增按钮
    addClick() {
      this.drawerType = "add";
      this.showDrawer = true;
    },
    editClick(row) {
      this.objInfo.deviceSnCode = row.deviceSnCode || "";
      this.objInfo.installationLocation = row.installationLocation || "";
      this.objInfo.name = row.name || "";
      this.objInfo.id = row.id || "";
      this.drawerType = "edit";
      this.showDrawer = true;
    },
    saveForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addOrEditForm();
        } else {
          return false;
        }
      });
    },
    async addOrEditForm() {
      let url =
        this.drawerType == "add" ? "addAirTestingInfo" : "editAirTestingInfo";
      let res = await this.$Http[url](Object.assign({}, this.objInfo));
      if (res.code == 200) {
        this.handleClose();
        this.searchClick();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage || "空气检测仪提交失败"
        });
      }
    },
    // 关闭弹窗
    handleClose() {
      this.showDrawer = false;
      this.recoverData();
    },
    // 恢复初始数据
    recoverData() {
      this.$refs.ruleForm.resetFields();
      this.objInfo = {
        deviceSnCode: "", //设备SN码
        installationLocation: "", //安装地点
        name: "", //名称
        schoolId: this.$store.state.schoolId, //所属学校
        id: ""
      };
    },
    // 删除提示框
    deldteClick(id) {
      this.$confirm("此操作将永久删除空气检测仪, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.deldteinfo({ id: id });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 删除数据
    async deldteinfo(ids) {
      let res = await this.$Http.delAirTestingInfo(ids, true);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "空气检测仪删除成功"
        });
        this.searchClick();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage || "空气检测仪删除失败"
        });
      }
    }
  },

  created() {},
  mounted() {
    this.searchClick();
  }
};
</script>
